<template>
	<ListAndCard
		:card-type="cardType"
		:image="project.image"
		:image-text="project.name"
		:url="project.url"
		:loading="project.saving"
	>
		<template slot="card-title">
			<div>
				<h3 class="headline mb-0">{{ project.name }}</h3>
				<div>
					{{ project.stats.activeReportsCount | formatNumber }}
					{{ project.stats.activeReportsCount === 1 ? 'report' : 'reports' }}
				</div>
				<div>
					{{ project.stats.activeArticlesCount | formatNumber }}
					{{ project.stats.activeArticlesCount === 1 ? 'article' : 'articles' }}
				</div>
				<div v-if="project.lastActive">
					Last active {{ fromNow(project.lastActive) }}
				</div>
			</div>
		</template>
		<template slot="list-title">
			<div class="headline">{{ project.name }}</div>
		</template>
		<template slot="list-additional">
			<v-flex xs2 sm1>
				<div class="text-xs-center">
					{{ project.stats.activeReportsCount | formatNumber }}
					{{ project.stats.activeReportsCount === 1 ? 'Report' : 'Reports' }}
				</div>
			</v-flex>
			<v-flex xs2 sm1>
				<div class="text-xs-center">
					{{ project.stats.activeArticlesCount | formatNumber }}
					{{ project.stats.activeArticlesCount === 1 ? 'Article' : 'Articles' }}
				</div>
			</v-flex>
			<v-flex xs2 sm1 v-if="project.lastActive">
				<div class="text-xs-center">
					Last active {{ fromNow(project.lastActive) }}
				</div>
			</v-flex>
		</template>
		<template slot="actions">
			<v-btn
				:to="project.url"
				:disabled="project.saving"
				ripple
				flat
			>
				View
			</v-btn>
			<v-spacer v-if="cardType !== 1"/>
			<v-menu
				top
				left
			>
				<v-btn
					v-if="canManageProjects"
					slot="activator"
					:disabled="project.saving"
					small
					icon
				>
					<v-icon>more_vert</v-icon>
				</v-btn>
				<v-list>
					<v-list-tile @click="$emit('edit', project)">
						<v-list-tile-title>Update</v-list-tile-title>
					</v-list-tile>
					<v-list-tile @click="$emit('archive', project)">
						<v-list-tile-title class="error--text">Archive Project</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
		</template>
	</ListAndCard>
</template>

<script>
import ListAndCard from '@/components/ListAndCard';
import moment from 'moment';

export default {
	components: {
		ListAndCard,
	},
	props: {
		project: { type: Object, required: true },
		cardType: { type: Number, default: 0 },
	},
	computed: {
		canManageProjects() {
			return this.project.userCan('manage_projects');
		},
	},
	methods: {
		fromNow(timestamp) {
			if (['', '0000-00-00 00:00:00'].includes(timestamp)) {
				return 'Never';
			}
			return moment(`${timestamp}Z`).fromNow();
		},
	},
};
</script>

<style>

</style>
